<div class="flex flex-col h-full gap-y-[10px]">

  <!-- ===== MOBILE / TABLET PANEL (tabs mode) ===== -->
  @if (showTabs()) {
<div class="flex flex-col bg-white overflow-hidden"
     [style.height]="mobilePanelHeight()">

    <!-- ═══ STICKY HEADER (red box) — NEVER SCROLLS ═══ -->
    <div class="flex-shrink-0 bg-white z-[99]">
      <!-- User info -->
      <div class="pt-[32px] pr-[13px] pb-[17px] pl-4">
        <div class="flex items-start justify-between gap-3">
          <div class="flex items-center gap-[10px] min-w-0 flex-1">
            @if (currentUser?.profile_picture) {
              <div class="relative w-[55px] h-[55px] flex-shrink-0 rounded-full overflow-hidden">
                <img [src]="currentUser!.profile_picture" alt="Profile"
                  class="w-[55px] h-[55px] rounded-full object-cover"
                  [class.blur-sm]="isProfilePictureBlocked()" />
                @if (isProfilePictureBlocked()) {
                  <img src="assets/icons/eye-icon-white.png" alt="Under review"
                    class="absolute inset-0 m-auto w-5 h-5 pointer-events-none" />
                }
              </div>
            } @else {
              <div class="avatar-initials w-[50px] h-[50px] !text-[20px] flex-shrink-0">
                {{ ((currentUser?.first_name ?? '') + ' ' + (currentUser?.last_name ?? '')) | initials }}
              </div>
            }
            <div class="min-w-0 flex-1">
             <div class="flex items-center gap-[8px] min-w-0 flex-wrap">
              <h2 class="text-xl leading-6 font-bold text-[#2F3A48] truncate min-w-0">
                {{ getUserName() }}
              </h2>
              @if (currentUser?.is_verified) {
                <span class="text-white text-[10px] px-2 py-0.5 rounded-full inline-flex items-center gap-1 bg-[#38ACA8] whitespace-nowrap flex-shrink-0">
                  <i class="pi pi-verified !text-[10px]"></i>
                  Verified
                </span>
              }
            </div>
              <p class="text-base  font-semibold text-[#2F3A48] mb-[2px] truncate">
                {{ currentUser?.email }}
              </p>
              <p class="text-xs text-[#334D6E] uppercase font-semibold tracking-wide">
                @switch (currentUser?.user_type) {
                  @case ('2') { Resident }
                  @case ('3') { Management }
                  @case ('4') { Service Provider }
                  @case ('5') { Contractor }
                }
              </p>
            </div>
          </div>
          <!-- 3-dots menu -->
          <div class="flex-shrink-0 relative">
            <button
              type="button"
              class="py-2"
              aria-label="Profile actions"
              aria-haspopup="menu"
              [attr.aria-expanded]="showDotsMenu()"
              (click)="toggleProfileMenu($event)">
              <i class="pi pi-ellipsis-v text-[#585F68] !text-[18px]"></i>
            </button>
            @if (showDotsMenu()) {
              <div class="fixed inset-0 z-[299]" (click)="showDotsMenu.set(false)"></div>
              <div class="absolute right-0 top-8 z-[300] bg-white rounded-[10px] min-w-[260px]
                          shadow-[0_4px_24px_rgba(0,0,0,0.12)]  py-[16px] border border-[#E6E9EF]">
                @if (!currentUser?.is_verified) {
                  <button type="button"
                    class="flex items-center gap-3 w-full px-[20px] py-3 hover:bg-[#F5F9FF] transition-colors text-left"
                    (click)="onGetVerified(); showDotsMenu.set(false)">
                    <img src="assets/icons/get-verified.svg" alt="get-verified" class="w-5 h-5">
                    <span class="text-lg leading-5 font-semibold text-heading">Get verified</span>
                  </button>
                }
                <button type="button"
                  class="flex items-center gap-3 w-full px-[20px] py-3 hover:bg-[#F5F9FF] transition-colors text-left"
                  (click)="onViewProfile(); showDotsMenu.set(false)">
                  <img src="assets/icons/profile.svg" alt="profile" class="w-5 h-5">
                  <span class="text-lg leading-5 font-semibold text-heading">View Profile Center</span>
                </button>
                <button type="button"
                  class="flex items-center gap-3 w-full px-[20px] py-3 hover:bg-[#F5F9FF] transition-colors text-left"
                  (click)="onLogout(); showDotsMenu.set(false)">
                  <img src="assets/icons/logout.svg" alt="logout" class="w-5 h-5">
                  <span class="text-lg leading-5 font-semibold text-heading">Logout</span>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
      
      <!-- Activity Stats Section -->
      <div class="px-4 mb-[20px] py-3 border-t border-b border-[#EBEFF2] flex flex-col gap-2">
        <div>
          <div class="text-[24px] font-bold text-[#192A3E] leading-7">{{ activityPointsWithTierDisplay() }}</div>
          <div class="text-xs text-[#334D6E] font-medium opacity-70">Activity Points &amp; Tier</div>
        </div>
        <div class="flex items-center gap-3 justify-between">
          <a routerLink="/activity-stats" class="text-base font-bold text-[#2A82B1] hover:underline">My Analytics</a>
          <button type="button" class="text-base font-bold text-[#2A82B1] hover:underline bg-transparent border-none cursor-pointer p-0" (click)="openInvitePopup()">Send Invite</button>
        </div>
      </div>

      <!-- Tabs row -->
      <div class="flex border-b border-[#EBEFF2]">
        <button
          class="flex-1 pb-[6px] px-[15px] max-[414px]:text-[18px] whitespace-nowrap text-[20px] font-bold border-b-8 leading-[25px] transition-colors"
          [class.text-[#192A3E]]="mobileActiveTab() === 'collabs'"
          [class.border-[#5E9AB9]]="mobileActiveTab() === 'collabs'"
          [class.text-[#939699]]="mobileActiveTab() !== 'collabs'"
          [class.border-transparent]="mobileActiveTab() !== 'collabs'"
          (click)="switchToCollabsTab()">
          My Collaborations
        </button>
        <button
          class="flex-1 pb-[6px] px-[15px] max-[414px]:text-[18px] text-[20px] font-bold border-b-8 leading-[25px] transition-colors"
          [class.text-[#192A3E]]="mobileActiveTab() === 'switch'"
          [class.border-[#5E9AB9]]="mobileActiveTab() === 'switch'"
          [class.text-[#939699]]="mobileActiveTab() !== 'switch'"
          [class.border-transparent]="mobileActiveTab() !== 'switch'"
          (click)="switchToSwitchTab()">
          Switch Account
        </button>
      </div>

      <!-- ── Per-tab sticky sub-header (Explore+Start OR Add Account) ── -->
       
      

    </div>
    <!-- ═══ END STICKY HEADER ═══ -->

    <!-- ═══ SCROLLABLE AREA ONLY ═══ -->
<div class="flex flex-col min-h-0"
     [class.flex-1]="mobileActiveTab() === 'switch'"
     [style.flex]="mobileActiveTab() === 'collabs' ? 'none' : null">

  @if (mobileActiveTab() === 'collabs') {

    <!-- Clipped rail container — height shrinks as content scrolls -->
    <div #collabRailContainer class="flex-1 min-h-0 overflow-hidden relative">


      <!-- Rail slides up via translateY -->
      <div [style.transform]="'translateY(-' + collabRailOffset() + 'px)'"
       style="will-change: transform;">

        <!-- Explore + Start buttons — slides up and hides -->
        <div #collabUpperSection class="px-[18px] pt-7 pb-0">
          <button
            class="flex items-center gap-5 w-full px-[10px] py-[6px] bg-[#F2F0EA] rounded-lg
                   text-[#334D6E] hover:bg-[#E8F0F8] transition-colors text-left"
            (click)="onExploreCollabs()">
            <img src="assets/icons/search.svg" class="w-[18px] h-[18px] flex-shrink-0" alt="explore" />
            <span class="font-semibold text-[#192A3E] text-xl leading-7">Explore Collaborations</span>
          </button>
          <button
            class="flex items-center gap-[10px] mt-[20px] mb-0 w-full text-[#334D6E] text-left"
            (click)="onStartCollab()">
            <span class="w-10 h-10 flex justify-center items-center bg-[#F2F0EA] rounded-[5px]">
              <img src="assets/icons/add.svg" class="w-[18px] h-[18px]">
            </span>
            <span class="font-semibold text-xl leading-7 text-[#192A3E]">Start a Collaboration</span>
          </button>
        </div>

        <!-- Collab list — independent inner scroll -->
<div #collabListScroll
     class="overflow-y-auto hide-scrollbar pb-[30px] border-t border-[#EBEFF2]"
     style="touch-action: pan-y; -webkit-overflow-scrolling: touch;"
     [style.height]="collabListMaxHeight()"
     (scroll)="onCollabListScroll($event)">
  <div class="px-[18px]">
    @if (isLoadingMyCollabs()) {
      <div class="flex flex-col gap-[30px] border-t border-[#EBEFF2] pt-8">
        @for (i of [1, 2, 3]; track i) {
          <div class="flex items-center gap-[10px]">
            <p-skeleton width="40px" height="40px" borderRadius="5px" styleClass="flex-shrink-0" />
            <div class="flex flex-col gap-2 flex-1 min-w-0">
              <p-skeleton width="70%" height="22px" borderRadius="4px" />
              <p-skeleton width="50%" height="16px" borderRadius="4px" />
            </div>
          </div>
        }
      </div>
    } @else if (myCollabs().length) {
      <div class="flex flex-col gap-[30px] border-t border-[#EBEFF2] pt-8">
        @for (collab of myCollabs(); track collab.collab_id) {
          <div class="flex items-center gap-[10px] cursor-pointer"
               (click)="onMobileCollabClick(collab.collab_id)">
            <img
              [src]="collab.display_image || fallbackImage"
              [alt]="collab.title"
              class="w-10 h-10 rounded-[5px] object-cover flex-shrink-0"
              (error)="onImgError($event)" />
            <div class="flex-1 min-w-0">
              <h4 class="text-[22px] leading-7 font-bold text-heading truncate">
                {{ collab.title }}
              </h4>
              @if (collab.relative_time) {
                <p class="text-base leading-4 text-[#192A3E] capitalize mt-1">
                  Viewed {{ collab.relative_time }}
                </p>
              }
            </div>
          </div>
        }
      </div>

      <!-- Pagination loader -->
      @if (isLoadingMoreCollabs()) {
        <div class="flex justify-center py-4">
          <img src="assets/icons/loader.gif" class="w-[50px] h-[50px]" alt="loading" />
        </div>
      }

    } @else {
      <div class="flex items-center flex-col gap-[10px] mt-8">
        <img src="assets/icons/no-group.svg" alt="no-group" class="w-[40px] h-[25px]">
        <p class="text-base text-[#5B6576] font-semibold text-center">No collaborations</p>
      </div>
    }
  </div>
</div>

      </div>
    </div>

  }

  <!-- Switch Account list -->
  @if (mobileActiveTab() === 'switch') {
    <!-- Clipped rail container — mirrors collabs rail -->
    <div #switchRailContainer class="flex-1 min-h-0 overflow-hidden relative">

      <!-- Rail slides up via translateY -->
      <div [style.transform]="'translateY(-' + switchRailOffset() + 'px)'"
           style="will-change: transform;">

        <!-- Add Account button — slides up and hides -->
        <div #switchUpperSection class="bg-white">
          <button class="flex items-center gap-[10px] px-[18px] py-[28px] text-[#334D6E] w-full transition-colors"
                  (click)="navigateToAddAccount()">
            <span class="w-10 h-10 flex justify-center items-center bg-[#F2F0EA] rounded-[5px]">
              <img src="assets/icons/add.svg" class="w-[18px] h-[18px]">
            </span>
            <span class="text-[#192A3E] font-semibold text-xl leading-7">Add Account</span>
          </button>
          <div class="border-t border-[#C8D0D5] mx-[18px]"></div>
        </div>

        <!-- Profile list — independent inner scroll -->
        <div #switchListScroll
     class="overflow-y-auto hide-scrollbar"
     style="touch-action: pan-y; -webkit-overflow-scrolling: touch;"
     [style.height]="switchListMaxHeight()"
     (scroll)="onSwitchListScroll($event)">

      @if (isLoadingProfiles) {
        <div class="flex flex-col gap-4 px-[18px] pt-4">
          @for (item of [1, 2, 3, 4]; track $index) {
            <div class="flex items-center gap-3">
              <p-skeleton width="40px" height="40px" borderRadius="50%" />
              <div class="flex-1">
                <p-skeleton width="100%" height="30px" borderRadius="0.25rem" />
              </div>
            </div>
          }
        </div>
      }

      @if (!isLoadingProfiles && sessionProfiles.length === 0) {
        <div class="flex flex-col items-center gap-2 px-4 py-8">
          <i class="pi pi-user text-[#9DAFC9] text-[40px]"></i>
          <p class="text-[16px] font-semibold text-heading">No added account</p>
        </div>
      }

      @if (!isLoadingProfiles && sessionProfiles.length > 0) {
        @if (showAccountMenuIndex() !== null) {
          <div class="fixed inset-0 z-[299]" (click)="showAccountMenuIndex.set(null)"></div>
        }
        <div class="py-[30px] pr-[11px] pl-[18px] gap-[30px] flex flex-col">
          @for (profile of sessionProfiles; track $index) {
            <div class="flex items-center justify-between gap-2 hover:bg-[#FBFAF6] transition-colors cursor-pointer"
                 (click)="onSwitchProfile(profile)">
              <div class="flex items-center gap-[10px] flex-1 min-w-0">
                <div class="relative flex-shrink-0">
                  <div class="relative w-10 h-10 rounded-full overflow-hidden">
                    @if (profile.user_details.profile_picture) {
                      <img [src]="profile.user_details.profile_picture" alt="Profile"
                        class="w-full h-full object-cover"
                        [class.blur-sm]="isPictureBlocked(profile.user_details.profile_picture_moderation_status)" />
                      @if (isPictureBlocked(profile.user_details.profile_picture_moderation_status)) {
                        <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-4 h-4 pointer-events-none" />
                      }
                    } @else {
                      <div class="avatar-initials w-10 h-10 !text-[11px]">
                        {{ getProfileName(profile) | initials }}
                      </div>
                    }
                  </div>
                  <img
                    [src]="profile.user_details.is_verified && profile.is_active
                      ? 'assets/icons/check.svg' : 'assets/icons/Group 1137.svg'"
                    class="absolute -bottom-0.5 -right-0.5 w-[18px] h-[18px] rounded-full"
                    [style.background-color]="profile.user_details.is_verified && profile.is_active
                      ? '#38ACA8' : '#E59214'" />
                </div>
                <div class="flex-1 min-w-0">
                  <h4 class="text-[22px] leading-7 font-bold text-[#192A3E] truncate">
                    {{ getProfileName(profile) }}
                  </h4>
                  <p class="text-base leading-4 text-[#192A3E] mt-1">
                    {{ getUserTypeLabel(profile.user_details.user_type) }}
                  </p>
                </div>
              </div>
              <div class="relative flex-shrink-0">
                <button type="button" class="p-1.5 hover:bg-gray-100 rounded-lg"
                  [attr.aria-expanded]="showAccountMenuIndex() === $index"
                  (click)="$event.stopPropagation(); toggleAccountMenu($event, profile, $index)">
                  <i class="pi pi-ellipsis-v text-gray-600 text-xs"></i>
                </button>
                @if (showAccountMenuIndex() === $index) {
                  <div class="absolute right-0 top-8 z-[300] bg-white rounded-[10px]
                              shadow-[0_4px_24px_rgba(0,0,0,0.12)] min-w-[260px] py-[16px] border border-[#E6E9EF]">
                    @if (!profile.user_details.is_verified) {
                      <button type="button"
                        class="flex items-center gap-3 w-full px-[20px] py-3 hover:bg-[#F5F9FF] transition-colors text-left"
                        (click)="$event.stopPropagation(); onGetVerified(); showAccountMenuIndex.set(null)">
                        <img src="assets/icons/get-verified.svg" class="w-5 h-5">
                        <span class="text-lg leading-5 font-semibold text-heading">Get verified</span>
                      </button>
                    }
                    <button type="button"
                      class="flex items-center gap-3 w-full px-[20px] py-3 hover:bg-[#F5F9FF] transition-colors text-left"
                      (click)="$event.stopPropagation(); onViewProfileCenter(); showAccountMenuIndex.set(null)">
                      <img src="assets/icons/profile.svg" class="w-5 h-5">
                      <span class="text-lg leading-5 font-semibold text-heading">View Profile Center</span>
                    </button>
                    <button type="button"
                      class="flex items-center gap-3 w-full px-[20px] py-3 hover:bg-[#F5F9FF] transition-colors text-left"
                      (click)="$event.stopPropagation(); onRemoveAccount(); showAccountMenuIndex.set(null)">
                      <img src="assets/icons/remove-dropdown-icon.svg" class="w-5 h-5">
                      <span class="text-lg leading-5 font-semibold text-heading">Remove from list</span>
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
        </div><!-- /inner scroll -->
      </div><!-- /translateY rail -->
    </div><!-- /#switchRailContainer -->
  }

</div>
    <!-- ═══ END SCROLLABLE AREA ═══ -->

  </div>
}
  
  <!-- ===== END MOBILE PANEL ===== -->

  @if (!showTabs()) {

  @if (isSuperAdmin) {
  <!-- ===== SUPER ADMIN: "View Account" global user search ===== -->
  <div class="w-[300px] box-border pt-4 pb-3 px-3 overflow-x-hidden">
    <!-- Search -->
    <div class="w-full flex items-center gap-2 bg-[#EBEFF2] rounded-[20px] px-3 h-[28px] mb-4">
      <img src="assets/icons/search.svg" class="w-[16px] h-[16px]" alt="search" />
      <input type="text" placeholder="View Account" 
        class="w-0 flex-1 min-w-0 bg-transparent border-none outline-none text-base text-[#192A3E] placeholder:text-heading placeholder:font-bold"
        [value]="viewAccountQuery()"
        (input)="onViewAccountInput($any($event.target).value)"
        (click)="$event.stopPropagation()" />
    </div>

    <div class="-mx-3 border-b border-[#EBEFF2] mb-3"></div>

    <h3 class="text-[20px] font-bold text-heading mb-2 truncate">
      {{ viewAccountQuery().trim() ? ('Results • ' + viewAccountResults().length) : 'Viewed Recently' }}
    </h3>

    <!-- Tabs -->
    <div class="-mx-3 px-3 border-b border-[#EBEFF2] mb-2 pb-2">
    <div class="w-full overflow-x-auto hide-scrollbar">
    <div class="flex items-center gap-1.5 w-max">
      <button type="button" class="px-2.5 py-1 rounded-full text-sm font-semibold transition-colors border whitespace-nowrap"
        [class.bg-[#192A3E]]="viewAccountTab() === 'all'" [class.text-white]="viewAccountTab() === 'all'" [class.border-[#192A3E]]="viewAccountTab() === 'all'"
        [class.bg-white]="viewAccountTab() !== 'all'" [class.text-[#334D6E]]="viewAccountTab() !== 'all'" [class.border-[#C8D0D5]]="viewAccountTab() !== 'all'"
        (click)="setViewAccountTab('all')">All</button>
      <button type="button" class="px-2.5 py-1 rounded-full text-sm font-semibold transition-colors border whitespace-nowrap"
        [class.bg-[#192A3E]]="viewAccountTab() === 'resident'" [class.text-white]="viewAccountTab() === 'resident'" [class.border-[#192A3E]]="viewAccountTab() === 'resident'"
        [class.bg-white]="viewAccountTab() !== 'resident'" [class.text-[#334D6E]]="viewAccountTab() !== 'resident'" [class.border-[#C8D0D5]]="viewAccountTab() !== 'resident'"
        (click)="setViewAccountTab('resident')">Resident</button>
      <button type="button" class="px-2.5 py-1 rounded-full text-sm font-semibold transition-colors border whitespace-nowrap"
        [class.bg-[#192A3E]]="viewAccountTab() === 'management'" [class.text-white]="viewAccountTab() === 'management'" [class.border-[#192A3E]]="viewAccountTab() === 'management'"
        [class.bg-white]="viewAccountTab() !== 'management'" [class.text-[#334D6E]]="viewAccountTab() !== 'management'" [class.border-[#C8D0D5]]="viewAccountTab() !== 'management'"
        (click)="setViewAccountTab('management')">Management</button>
        <button type="button" class="px-2.5 py-1 rounded-full text-sm font-semibold transition-colors border whitespace-nowrap"
        [class.bg-[#192A3E]]="viewAccountTab() === 'service-provider'" [class.text-white]="viewAccountTab() === 'service-provider'" [class.border-[#192A3E]]="viewAccountTab() === 'service-provider'"
        [class.bg-white]="viewAccountTab() !== 'service-provider'" [class.text-[#334D6E]]="viewAccountTab() !== 'service-provider'" [class.border-[#C8D0D5]]="viewAccountTab() !== 'service-provider'"
        (click)="setViewAccountTab('service-provider')">Service Provider</button>
        <button type="button" class="px-2.5 py-1 rounded-full text-sm font-semibold transition-colors border whitespace-nowrap"
        [class.bg-[#192A3E]]="viewAccountTab() === 'contractor'" [class.text-white]="viewAccountTab() === 'contractor'" [class.border-[#192A3E]]="viewAccountTab() === 'contractor'"
        [class.bg-white]="viewAccountTab() !== 'contractor'" [class.text-[#334D6E]]="viewAccountTab() !== 'contractor'" [class.border-[#C8D0D5]]="viewAccountTab() !== 'contractor'"
        (click)="setViewAccountTab('contractor')">Contractor</button>
    </div>
    </div>
    </div>

    <!-- List -->
    <div class="max-h-[220px] overflow-y-auto overflow-x-hidden scroll-smooth -mx-3">
      @if (viewAccountQuery().trim() && viewAccountLoading()) {
        <p class="text-[12px] text-[#5B6576] py-3 text-center">Searching...</p>
      } @else if (!viewAccountQuery().trim() && viewedRecentlyLoading()) {
        <div class="flex flex-col gap-1 py-1 animate-pulse">
          @for (_ of [1,2,3]; track $index) {
            <div class="flex items-center gap-2 py-2 pr-2 pl-3">
              <div class="w-8 h-8 rounded-full bg-[#E6E9EF] flex-shrink-0"></div>
              <div class="flex-1 min-w-0 flex flex-col gap-1.5">
                <div class="w-[70%] h-[11px] rounded bg-[#E6E9EF]"></div>
                <div class="w-[40%] h-[9px] rounded bg-[#E6E9EF]"></div>
              </div>
            </div>
          }
        </div>
      } @else if (viewAccountDisplayList().length) {
        @for (result of viewAccountDisplayList(); track result.user_id) {
          <div class="flex items-center justify-between gap-1 py-2 hover:bg-[#F5F9FF] rounded-lg pr-2 pl-3 transition-colors relative">
            <button type="button" class="flex items-center gap-2 flex-1 min-w-0 text-left" (click)="onViewAccountRowClick(result)">
              @if (result.profile_picture) {
                <img [src]="result.profile_picture" class="w-8 h-8 rounded-full object-cover flex-shrink-0" alt="" />
              } @else {
                <div class="w-8 h-8 rounded-full bg-[#2E7FBE] flex items-center justify-center text-white text-[11px] font-bold flex-shrink-0">
                  {{ getViewAccountName(result) | initials }}
                </div>
              }
              <span class="flex-1 min-w-0">
                <span class="block text-[13px] font-bold text-[#192A3E] truncate">{{ getViewAccountName(result) }}</span>
                <span class="block text-[10px] text-[#5B6576] font-semibold uppercase tracking-wide truncate">{{ getViewAccountRoleLabel(result) }}</span>
              </span>
            </button>
            <div class="relative flex-shrink-0">
              <button type="button" class="p-1 hover:bg-gray-100 rounded-lg" (click)="$event.stopPropagation(); toggleViewAccountRowMenu(result, $event)">
                <i class="pi pi-ellipsis-v text-gray-500 text-xs"></i>
              </button>
              @if (activeViewAccountRowMenu() === result.user_id && viewAccountRowMenuPosition(); as pos) {
                <div class="fixed inset-0 z-[299]" (click)="activeViewAccountRowMenu.set(null); viewAccountRowMenuPosition.set(null)"></div>
                <div class="fixed z-[300] bg-white rounded-[10px] w-[160px] shadow-[0_4px_24px_rgba(0,0,0,0.12)] py-2 border border-[#E6E9EF]"
                  [style.top.px]="pos.top" [style.left.px]="pos.left">
                  <button type="button" class="flex items-center gap-3 w-full px-4 py-2 hover:bg-[#F5F9FF] text-left" (click)="onBanAccount(result)">
                    <img src="assets/icons/super-admin-ban-icon.svg">
                    <span class="text-sm font-semibold text-heading">Ban</span>
                  </button>
                  <button type="button" class="flex items-center gap-3 w-full px-4 py-2 hover:bg-[#F5F9FF] text-left" (click)="onBlockAccountAccess(result)">
                    <img src="assets/icons/super-admin-block-icon.svg">
                    <span class="text-sm font-semibold text-heading">Block Access</span>
                  </button>
                  <button type="button" class="flex items-center gap-3 w-full px-4 py-2 hover:bg-[#F5F9FF] text-left" (click)="onActivateAccount(result)">
                    <img src="assets/icons/super-admin-activate-icon.svg">
                    <span class="text-sm font-semibold text-heading">Activate</span>
                  </button>
                  <button type="button" class="flex items-center gap-3 w-full px-4 py-2 hover:bg-[#F5F9FF] text-left" (click)="onVerifyAccount(result)">
                    <img src="assets/icons/super-admin-verified-icon.svg">
                    <span class="text-sm font-semibold text-heading">Verified</span>
                  </button>
                  <button type="button" class="flex items-center gap-3 w-full px-4 py-2 hover:bg-[#F5F9FF] text-left" (click)="onEditAccount(result)">
                    <img src="assets/icons/edit-icon.svg">
                    <span class="text-sm font-semibold text-heading">Edit</span>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      } @else {
        <p class="text-sm text-[#232F40] text-center py-6 border-b border-[#EBEFF2] -mx-3">{{ viewAccountQuery().trim() ? 'No matching accounts found.' : 'No Recently Viewed' }}</p>
      }
    </div>
    <!-- Logout -->
    <button type="button" class="flex items-center gap-2 -mx-3 px-4 py-2.5 mt-2  hover:bg-[#F5F9FF] transition-colors text-left" (click)="onLogout()">
      <img src="assets/icons/logout.svg" alt="logout" class="w-4 h-4">
      <span class="text-base font-semibold text-heading">Logout</span>
    </button>
  </div>
  } @else {

  @if (!showProfileInfo) {
  <!-- Header Dropdown Action Items (Figma style) -->
  <div class="py-1 min-w-[220px] pt-[25px]">
    @if (!currentUser?.is_verified) {
    <button type="button" class="flex items-center gap-3 w-full px-[20px] py-3 hover:bg-[#F5F9FF] transition-colors text-left" (click)="onGetVerified()">
      <img src="assets/icons/get-verified.svg" alt="get-verified" class="w-5 h-5">
      <span class="text-base leading-5 font-semibold text-heading">Get verified</span>
    </button>
    }
    <button type="button" class="flex items-center gap-3 w-full px-[20px] py-3 hover:bg-[#F5F9FF] transition-colors text-left" (click)="onViewProfile()">
      <img src="assets/icons/profile.svg" alt="profile" class="w-5 h-5">
      <span class="text-base leading-5 font-semibold text-heading">View Profile Center</span>
    </button>
    <button type="button" class="flex items-center gap-3 w-full px-[20px] py-3 hover:bg-[#F5F9FF] transition-colors text-left" (click)="onLogout()">
      <img src="assets/icons/logout.svg" alt="logout" class="w-5 h-5">
      <span class="text-base leading-5 font-semibold text-heading">Logout</span>
    </button>
  </div>
  }

  @if (showProfileInfo) {
  <div [class]="
     showBorder
        ? 'bg-white rounded-[10px] p-4  border border-[#C8D0D5] sticky top-0'
        : 'bg-white p-4  rounded-[10px]  '
    ">
    <div class="flex items-center justify-between gap-3 mb-3">
      <div class="flex items-center gap-4">
        @if (!currentUser || isLoadingContactMetrics() ) {
        <p-skeleton width="50px" height="50px" borderRadius="50%" />
        <div class="flex flex-col gap-2">
          <p-skeleton width="130px" height="23px" borderRadius="5px" />
          <!-- <p-skeleton width="85px" height="22px" borderRadius="9999px" /> -->
        </div>
        }
        @if (currentUser &&  !isLoadingContactMetrics() ) {

        @if (currentUser.profile_picture) {
        <div class="relative w-[50px] h-[50px] flex-shrink-0 rounded-full overflow-hidden">
          <img [src]="currentUser.profile_picture" alt="Profile"
            class="w-[50px] h-[50px] rounded-full object-cover"
            [class.blur-sm]="isProfilePictureBlocked()"
            [class.cursor-pointer]="isDesktop" (click)="onProfileClick($event)" />
          @if (isProfilePictureBlocked()) {
            <img src="assets/icons/eye-icon-white.png" alt="Under review"
              class="absolute inset-0 m-auto w-5 h-5 pointer-events-none" />
          }
        </div>
        } @else {
        <div class="avatar-initials w-[50px] h-[50px] !text-[20px]" [class.cursor-pointer]="isDesktop"
          (click)="onProfileClick($event)">
          {{ (currentUser.first_name + ' ' + currentUser.last_name) | initials }}
        </div>
        }
        <div class="flex flex-col gap-1">
          <h2 class="text-[18px] font-bold text-[#334D6E]">
            {{ currentUser.first_name + ' ' + currentUser.last_name }}
          </h2>
          <span class="text-white text-[10px] px-2 py-1 rounded-full flex items-center gap-1 w-fit"
            [class.bg-warn]="!currentUser.is_verified" [class.bg-darkSuccess]="currentUser.is_verified">
            <i class="pi !text-[10px]" [class.pi-info-circle]="!currentUser.is_verified"
              [class.pi-verified]="currentUser.is_verified"></i>
            {{ currentUser.is_verified ? 'Verified' : 'Get Verified' }}
          </span>
        </div>
        }
      </div>
      <div class="flex justify-end">
        @if (!isDesktop) {
        <button class="p-2" (click)="toggleProfileMenu($event)">
          <i class="pi pi-ellipsis-v text-[#585F68] !text-[16px]"></i>
        </button>
        }
        <p-menu #profileMenu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
      </div>
    </div>

    @if (!isContactRoute && !isFundraiseRoute) {
    <div class="ml-0">
      <p class="text-sm text-[#334D6E] font-semibold truncate">{{ currentUser?.email }}</p>
      <p class="text-sm text-[#334D6E] font-semibold">{{ currentUser?.mobile }}</p>
      <p class="text-sm text-[#334D6E] uppercase tracking-wide font-semibold">
        @switch (currentUser?.user_type) { @case ('2') { Resident } @case ('3') { MANAGEMENT } @case
        ('4') { SERVICE PROVIDER } @case ('5') { CONTRACTOR } }
      </p>
    </div>
    }

    <div class="mt-4 pt-3 border-t border-b border-[#EBEFF2] flex flex-col gap-2">
      <div>
        <div class="text-[24px] font-bold text-[#192A3E] leading-7">{{ activityPointsWithTierDisplay() }}</div>
        <div class="text-xs text-[#334D6E] font-medium opacity-70">Activity Points &amp; Tier</div>
      </div>
      <div class="flex items-center gap-3">
        <a routerLink="/activity-stats" class="text-base font-bold text-[#2A82B1] hover:underline">See Stats</a>
        <button type="button" class="text-base font-bold text-[#2A82B1] hover:underline bg-transparent border-none cursor-pointer p-0" (click)="openInvitePopup()">Send Invite</button>
      </div>
    </div>

  </div>
  }



  @if (showSwitchAccount) {
  <hr class="lg:hidden" />
  <div class="" [class]="
      showBorder
        ? 'bg-white rounded-[10px] shadow-sm border border-[#C8D0D5]'
        : 'bg-white'
    ">
    <h3 class="text-[20px] font-bold text-heading p-4 border-b border-t border-[#EBEFF2] mt-[10px]">
      Switch Account
      <span class="text-[18px]" [attr.aria-label]="'Available profiles: ' + sessionProfiles.length">• {{
        sessionProfiles.length }}</span>
    </h3>

    @if (isLoadingProfiles) {
    <div class="space-y-4">
      @for (item of [1, 2, 3, 4]; track $index) {
      <div class="flex items-center gap-3 pl-[20px] pr-[11px] py-4">
        <div class="flex-shrink-0">
          <p-skeleton width="25px" height="25px" borderRadius="50%" />
        </div>
        <div class="flex-1">
          <p-skeleton width="100%" height="30px" borderRadius="0.25rem" />
        </div>
      </div>
      }
    </div>
    } @if (!isLoadingProfiles && sessionProfiles.length === 0) {
    <div class="flex flex-col items-center gap-2 px-4 py-6">
      <i class="pi pi-user text-[#9DAFC9] text-[40px]"></i>
      <p class="text-[16px] font-semibold text-heading">No added account</p>
    </div>
    } @if (!isLoadingProfiles && sessionProfiles.length > 0) {
    <div (wheel)="onCarouselWheel($event)"
      class="lg:max-h-[304px] overflow-y-auto lg:overflow-y-hidden lg:hover:overflow-y-auto hide-scrollbar custom-scrollbar">
      <div class="flex-1 min-h-0 space-y-1">
        @for (profile of sessionProfiles; track $index) {
        <div
          class="flex items-center justify-between gap-2 hover:bg-[#FBFAF6] transition-colors cursor-pointer px-4 py-4"
          (click)="onSwitchProfile(profile)">
          <!-- Left -->
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <div class="relative flex-shrink-0">
              <div class="relative w-8 h-8 rounded-full overflow-hidden">
                @if (profile.user_details.profile_picture) {
                <img [src]="profile.user_details.profile_picture" alt="Profile" class="w-full h-full object-cover"
                  [class.blur-sm]="isPictureBlocked(profile.user_details.profile_picture_moderation_status)" />
                @if (isPictureBlocked(profile.user_details.profile_picture_moderation_status)) {
                  <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-3 h-3 pointer-events-none" />
                }
                } @else {
                <div class="avatar-initials w-8 h-8 !text-[11px]">
                  {{ getProfileName(profile) | initials }}
                </div>
                }
              </div>

              <img [src]="
                    profile.user_details.is_verified && profile.is_active
                      ? 'assets/icons/check.svg'
                      : 'assets/icons/Group 1137.svg'
                  " [alt]="profile.is_active ? 'Active' : 'Pending'"
                class="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 rounded-full" [style.background-color]="
                    profile.user_details.is_verified && profile.is_active
                      ? '#3380A9'
                      : '#E59214'
                " />
            </div>

            <div class="flex-1 min-w-0">
              <h4 class="text-[12px] font-semibold text-[#334D6E] truncate">
                {{ getProfileName(profile) }}
              </h4>
              <p class="text-[10px] font-semibold text-[#334D6E] uppercase mt-1">
                {{ getUserTypeLabel(profile.user_details.user_type) }}
              </p>
            </div>
          </div>

          <!-- Right -->
          <button class="p-1 hover:bg-gray-100 rounded-lg flex-shrink-0" (click)="toggleAccountMenu($event, profile)">
            <i class="pi pi-ellipsis-v text-gray-600 text-xs"></i>
          </button>
        </div>
        }
        <p-menu #accountMenu [model]="accountMenuItems" [popup]="true" appendTo="body"></p-menu>
      </div>
    </div>
    }

    <button
      class="flex items-center justify-between w-full pb-2 text-[#334D6E] hover:bg-gray-50 p-4 rounded-lg transition-colors border-t border-[#EBEFF2]"
      (click)="navigateToAddAccount()">
      <span class="font-medium text-base">Add account</span>
      <i class="pi pi-plus text-xl leading-5 text-[#109CF1]"></i>
    </button>
  </div>
  }

  } <!-- end @else (!isSuperAdmin) -->

  } <!-- end @if (!showTabs()) -->

</div>
<pa-collab-list
  [seeAllCollab]="false"
  [showList]="false"
  (collabCreated)="fetchMyCollabs()"
></pa-collab-list>

<pa-invite-popup
  [isVisible]="showInvitePopup()"
  title="Invite Friends"
  [itemTitle]="((currentUser?.first_name || '') + ' ' + (currentUser?.last_name || '')).trim()"
  [itemImage]="currentUser?.profile_picture || ''"
  [itemImageModerationStatus]="currentUser?.profile_picture_moderation_status ?? null"
  path="/get-started/profile"
  [referrerToken]="referralToken()"
  (closePopup)="showInvitePopup.set(false)"
></pa-invite-popup>
